<template>
  <!-- <div id="app">
    <el-card class="box-card">
      <div class="box_top">
        <h2>瑞银文件管理系统</h2>
      </div>
      <div class="tabs">
        <el-radio-group v-model="typeOperation" size="mini">
          <el-radio-button label="login">登录</el-radio-button>
          <el-radio-button label="register">注册</el-radio-button>
        </el-radio-group>
      </div>
      <loginElement v-if="typeOperation==='login'"></loginElement>
      <registerElement v-if="typeOperation==='register'"></registerElement>

    </el-card>
  </div> -->

  <!-- 自动登录全屏 loading -->
  <!-- <div v-if="autoLogging" class="auto-login-mask">
    <div class="auto-login-box">
      <i class="el-icon-loading"></i>
      <p>正在登录，请稍候...</p>
    </div>
  </div>-->

  <div class="login-warpper">
    <div class="container">
      <div class="flex">
        <div class="poster">
          <div class="logo">瑞银文件管理系统</div>
          <div class="poster-content">
            <img src="~@/assets/svg/upload.svg" class="p-box" />
          </div>
        </div>
        <div class="form">
          <h2 class="title">登录</h2>
          <div class="user-layout-login">
            <el-form :model="ruleForm" :rules="rules" label-position="left" ref="ruleForm" label-width="100px">
              <el-form-item label="帐号：" prop="username">
                <el-input placeholder="请输入帐号"
                  onkeydown="if(event.keyCode==13) {document.getElementById('btn').click();return false;}"
                  v-model="ruleForm.username"></el-input>
              </el-form-item>
              <el-form-item label="密码：" prop="password">
                <el-input type="password" show-password placeholder="请输入密码"
                  onkeydown="if(event.keyCode==13) {document.getElementById('btn').click();return false;}"
                  v-model="ruleForm.password" />
              </el-form-item>
              <el-form-item label="验证码：" prop="code">
                <div style="display: flex; align-items: center;">
                  <el-input type="text" placeholder="请输入验证码"
                    onkeydown="if(event.keyCode==13) {document.getElementById('btn').click();return false;}"
                    v-model="ruleForm.code"></el-input>
                  <div class="login-code">
                    <img :src="codeUrl" @click="getCode(true)" alt="验证码">
                  </div>
                </div>
              </el-form-item>
            </el-form>
            <div style="width: 100%;text-align: center">
              <el-button style="width: 100%;" type="primary" id="btn" @click="login()">登录</el-button>
            </div> <!-- <registerElement v-if="typeOperation === 'register'"></registerElement> -->
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Vue from 'vue'
import * as u from '@/utils/util'
import {
  hasSsoCredentials,
  getSsoCredentials,
  clearSsoCredentials,
  getSsoRedirect,
  tryProcessSso,
  clearQueryFromUrl,
  SSO_CAPTCHA
} from '@/utils/sso'
export default {
  name: "login",
  components: {
    'loginElement': () => import('@/components/auth/loginElement.vue'),
    'registerElement': () => import('@/components/auth/registerElement.vue'),
  },
  data() {
    return {
      //操作类型-登录-注册
      typeOperation: "login",
      // 检测到 URL 带 username 参数时显示全屏 loading
      autoLogging: false, // 自动登录时显示 loading
      autoLoginStarted: false,
      //登录表单
      ruleForm: {
        code: '',
        randomStr: u.uuid(),
      },
      //登录校验
      rules: {
        username: [
          { required: true, message: '请输入帐号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      },
      //验证码图片url
      codeUrl: "",
    }
  },
  created() {
    // 兼容 #/login?username=...&password=... 链接格式（对接方无法改链接）
    tryProcessSso(this.$route)
    // 用 replaceState 清 query，避免 router.replace 导致组件重载 / 重复 getCode
    if (window.location.hash.includes('?')) {
      clearQueryFromUrl(true)
    }
    this.initPage()
  },
  methods: {
    initPage() {
      // 必须先等 getCode 完成再登录，否则 randomStr 未注册会报「验证码过期」
      this.getCode().then(() => {
        this.tryAutoLogin()
      })
    },
    tryAutoLogin() {
      if (!hasSsoCredentials() || this.autoLoginStarted) {
        return
      }
      this.autoLoginStarted = true
      this.autoLogging = true
      const credentials = getSsoCredentials()
      this.ruleForm.username = credentials.username
      this.ruleForm.password = credentials.password
      this.ruleForm.code = SSO_CAPTCHA
      this.confirmLogin(true)
    },
    //获取验证码；仅手动刷新时更换 randomStr，免登须与登录请求保持一致
    getCode(regenerate = false) {
      if (regenerate) {
        this.ruleForm.randomStr = u.uuid();
      }
      return this.$HttpService.get("/sys-login/getCode", {
        randomStr: this.ruleForm.randomStr,
      }).then(res => {
        this.codeUrl = res;
      })
    },
    // 统一登录执行方法（auto=true 时为自动登录，跳过表单校验）
    confirmLogin(auto) {
      const doLogin = () => {
        this.$HttpService.post("/sys-login/login", this.ruleForm).then(res => {
          // 设置存储用户基本信息
          this.$util.setLoginInfo(res);
          // 设置登录状态到 Vuex store
          this.$store.commit('SET_LOGIN_STATE', true);
          // 清除 SSO 临时凭证
          clearSsoCredentials();
          // 优先：query.redirect → SSO hash 目标路由 → 默认首页
          const redirect = this.$route.query.redirect || getSsoRedirect();
          setTimeout(() => {
            if (redirect) {
              this.$router.push(redirect);
            } else {
              this.$router.push({ path: "/file/myFileTree" });
            }
          }, 200);
        }).catch(() => {
          this.autoLoginStarted = false
          this.getCode();
        });
      };

      // auto=true 时为自动登录，直接跳过表单校验执行
      if (auto) {
        // this.ruleForm.checkKey = new Date().getTime();
        doLogin();
      } else {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            doLogin();
          }
        });
      }
    },
    // 登录按钮点击
    login() {
      this.confirmLogin();
    }
  }
}
</script>
<style lang="less" scoped>
.auto-login-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  .auto-login-box {
    text-align: center;
    color: #409EFF;

    i {
      font-size: 48px;
      animation: spin 1s linear infinite;
    }

    p {
      margin-top: 16px;
      font-size: 15px;
      color: #666;
    }
  }
}

.loginElement {
  .auto-login-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 0;
    color: #409EFF;

    i {
      font-size: 32px;
      animation: rotating 1s linear infinite;
    }

    span {
      margin-top: 12px;
      font-size: 14px;
      color: #666;
    }
  }

  @keyframes rotating {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  .login-code {
    margin-left: 10px;
    cursor: pointer;

    img {
      height: 40px;
      border-radius: 4px;
    }
  }

  // ==================== 移动端适配 ====================
  @media screen and (max-width: 768px) {
    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 16px;

        .el-form-item__label {
          font-size: 13px;
          line-height: 38px;
          padding: 0 6px 0 0;
          width: 65px !important;
        }

        .el-form-item__content {
          line-height: 38px;
          margin-left: 65px !important;

          .el-input {
            .el-input__inner {
              height: 38px;
              line-height: 38px;
              font-size: 14px;
              padding: 0 12px;
              border-radius: 5px;
            }

            .el-input__suffix {
              .el-input__suffix-inner {
                line-height: 38px;

                .el-icon-view,
                .el-icon-circle-close {
                  font-size: 15px;
                }
              }
            }
          }
        }
      }
    }

    .login-code {
      margin-left: 6px;
      flex-shrink: 0;

      img {
        height: 38px;
        width: 85px;
        border-radius: 5px;
      }
    }

    ::v-deep .el-button {
      height: 38px;
      font-size: 15px;
      border-radius: 5px;
      font-weight: 500;
    }
  }

  // 小屏幕手机适配（宽度小于 480px）
  @media screen and (max-width: 480px) {
    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 14px;

        .el-form-item__label {
          font-size: 13px;
          line-height: 36px;
          width: 60px !important;
        }

        .el-form-item__content {
          line-height: 36px;
          margin-left: 60px !important;

          .el-input {
            .el-input__inner {
              height: 36px;
              line-height: 36px;
              font-size: 14px;
              padding: 0 10px;
            }

            .el-input__suffix {
              .el-input__suffix-inner {
                line-height: 36px;
              }
            }
          }
        }
      }
    }

    .login-code {
      margin-left: 6px;

      img {
        height: 36px;
        width: 80px;
      }
    }

    ::v-deep .el-button {
      height: 36px;
      font-size: 14px;
    }
  }

  // 横屏模式适配
  @media screen and (max-width: 768px) and (orientation: landscape) {
    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 12px;

        .el-form-item__label {
          line-height: 34px;
        }

        .el-form-item__content {
          line-height: 34px;

          .el-input {
            .el-input__inner {
              height: 34px;
              line-height: 34px;
              font-size: 13px;
            }

            .el-input__suffix {
              .el-input__suffix-inner {
                line-height: 34px;
              }
            }
          }
        }
      }
    }

    .login-code {
      img {
        height: 34px;
        width: 75px;
      }
    }

    ::v-deep .el-button {
      height: 34px;
      font-size: 13px;
    }
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.login-warpper {
  min-height: 100%;
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin-left: -48%;
    background-image: url(~@/assets/svg/login-bg.svg);
    background-position: 100%;
    background-repeat: no-repeat;
    background-size: auto 100%;
    content: "";
  }

  .container {
    position: relative;
    height: 100%;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;

    .flex {
      display: flex;
      height: 100%;

      .poster {
        width: 50%;
        padding: 40vh 0;
        text-align: center;

        .logo {
          width: 50%;
          position: absolute;
          top: 20%;
          font-size: 28px;
          font-weight: 700;
          transition: all 0.5s;
          line-height: normal;
          color: #fff;

        }

        .poster-content {
          margin-top: auto;
          margin-bottom: auto;

          .p-box {
            transition: all 0.5s;
            width: 290px;
          }
        }
      }

      .form {
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .title {
          font-size: 30px;
          font-weight: bold;
          opacity: 0.9;
          margin-bottom: 20px;
        }

        .user-layout-login {
          width: 400px;

          label {
            font-size: 14px;
          }

          .forge-password {
            font-size: 14px;
          }

          button.login-button {
            padding: 0 15px;
            font-size: 16px;
            height: 40px;
            width: 100% !important;
          }
        }
      }
    }
  }

  // ==================== 移动端适配 ====================
  @media screen and (max-width: 768px) {
    &::before {
      margin-left: 0;
      background-size: cover;
      background-position: center;
      opacity: 0.3;
    }

    .container {
      // padding: 0 20px;

      .flex {
        flex-direction: column;
        justify-content: center;

        .poster {
          width: 100%;
          padding: 0;
          text-align: center;
          margin-bottom: 30px;

          .logo {
            position: relative;
            top: auto;
            font-size: 24px;
            color: #333;
            margin-bottom: 20px;
            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          }

          .poster-content {
            display: none; // 移动端隐藏装饰图片
          }
        }

        .form {
          width: 100%;
          padding: 0;

          .title {
            font-size: 24px;
            margin-bottom: 24px;
            color: #333;
          }

          .user-layout-login {
            width: 100%;
            max-width: 340px;
            padding: 30px 20px;
            background: rgba(255, 255, 255, 0.95);
            border-radius: 12px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

            label {
              font-size: 14px;
            }

            .forge-password {
              font-size: 13px;
            }

            button.login-button {
              padding: 0 15px;
              font-size: 15px;
              height: 42px;
              width: 100% !important;
            }
          }
        }
      }
    }
  }

  // 小屏幕手机适配（宽度小于 480px）
  @media screen and (max-width: 480px) {
    .container {
      // padding: 0 16px;

      .flex {
        .poster {
          margin-bottom: 20px;

          .logo {
            font-size: 20px;
            margin-bottom: 16px;
          }
        }

        .form {
          .title {
            font-size: 20px;
            margin-bottom: 20px;
          }

          .user-layout-login {
            padding: 24px 16px;
            border-radius: 10px;

            label {
              font-size: 13px;
            }

            .forge-password {
              font-size: 12px;
            }

            button.login-button {
              font-size: 14px;
              height: 40px;
            }
          }
        }
      }
    }
  }

  // 横屏模式适配
  @media screen and (max-width: 768px) and (orientation: landscape) {
    .container {
      .flex {
        flex-direction: row;
        align-items: center;

        .poster {
          width: 40%;
          margin-bottom: 0;
          padding-right: 20px;

          .logo {
            font-size: 20px;
            margin-bottom: 12px;
          }

          .poster-content {
            display: block;

            .p-box {
              width: 150px;
            }
          }
        }

        .form {
          width: 60%;

          .title {
            font-size: 22px;
            margin-bottom: 16px;
          }

          .user-layout-login {
            padding: 20px 16px;
          }
        }
      }
    }
  }

  // 平板竖屏适配（768px - 1024px）
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    .container {
      max-width: 900px;
      padding: 0 40px;

      .flex {
        .poster {
          .logo {
            font-size: 26px;
          }

          .poster-content {
            .p-box {
              width: 240px;
            }
          }
        }

        .form {
          .title {
            font-size: 28px;
          }

          .user-layout-login {
            width: 380px;
          }
        }
      }
    }
  }
}
</style>
<!-- 
<style scoped lang="scss">
#app {
  width: 100%;
  height: 100%;
   background-size: 100%;
   &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin-left: -48%;
    background-image: url(~@/assets/login-bg.svg);
    background-position: 100%;
    background-repeat: no-repeat;
    background-size: auto 100%;
    content: "";
  }
}

.box_top {
  text-align: center;
  padding: 30px;
}

.box-card {
  width: 500px;
  height: 450px;
  padding: 20px;
  margin:  auto;
  // margin-top: 15vh;
  // display: flex; 
  border-radius: 30px;

  .tabs{
    text-align: center;
    margin-bottom: 20px;
  }
  .three_login {
    border-top: 1px solid #dddddd;
    margin-top: 10px;
    padding-top: 10px;
    display: flex;
    width: 100%;

    .group {
      margin: 0 auto;

      span {
        font-size: 12px;
      }

      .el-avatar {
        background: white;
      }
    }

    .group:hover {
      span {
        color: #a73e11;
        cursor: pointer;
      }
    }

  }
}

</style> -->
